/** Copyright 2024 SAP SE or an SAP affiliate company. All rights reserved. */
import { freApi } from '@/store/apis';
import reducer from '@/store/reducer';
import { configureStore } from '@reduxjs/toolkit';
import { loadingMiddleware } from './loadingSlice';
import { productSlice } from './Products';
import { feedbackSlice } from './feedbackSlice';
import { setFeedbackServiceDispatch } from '@/utils/FeedbackService';

export const middlewares = [freApi.middleware, loadingMiddleware(productSlice), loadingMiddleware(feedbackSlice)];
const store = configureStore({ reducer, middleware: getDefaultMiddleware => getDefaultMiddleware().concat(...middlewares) });
setFeedbackServiceDispatch(store.dispatch);
export default store;
